<div class="hero h-full" style="background-image: url(location_img.jpg)">
    <div class="hero-overlay bg-opacity-10"></div>
    <div class="hero-content text-center text-neutral-content w-full">
        <div class="w-full">
            <h1 class="text-6xl text-green-800 font-normal">Location</h1>
            <div id="map-9cd199b9cc5410cd3b1ad21cab2e54d3" class="w-full md:p-16">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d324.12674095260104!2d86.1279299078693!3d23.203931345015523!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f5d1d2bcd1221f%3A0x5e5f102b0f237b8c!2sThe%20Outlook%20Inn!5e0!3m2!1sen!2sin!4v1720710395883!5m2!1sen!2sin"
                    height="540"
                    style="max-width: 100%; width: 100%; border: medium; padding: 0px; margin: 0px; height: 540px"
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
            </div>
        </div>
    </div>
</div>
